import React, { useEffect, useState } from 'react';
import { Card, Collapse, List, Space } from 'antd';
import { TableSecProps } from './props';

import ListSteps from '../ListSteps';
import { RowLine, SpanBlock } from './styles';
import { AgendamentoServices } from '../../services/AgendamentoServices';
import { maskCurrency, maskUnd } from '../../../../../../utils/mask';
import ModalUpload from '../Modal/ModalUpload';

const CardSecMobile: React.FC<TableSecProps> = ({ nuNota, props, inscricaoAtiva }) => {
  const { Panel } = Collapse;

  const [loadingSec, setLoadingSec] = useState(false);
  const [response, setResponse] = useState();

  useEffect(() => {
    let controller = new AbortController();
    try {
      setLoadingSec(true);
      AgendamentoServices.getPedidosOrdemCarga(
        props.codOrdemCarga,
        props.codCentroDistribuicao,
        inscricaoAtiva
      ).then((res) => {
        setResponse(res?.data.pedidos);
      });
    } finally {
      setLoadingSec(false);
    }
    return () => {
      controller.abort();
    };
  }, [inscricaoAtiva, props]);

  return (
    <Collapse key={nuNota}>
      <Panel header="Detalhes" key={nuNota}>
        <>
          <Space className="full-width" direction="vertical" size="small">
            <ListSteps record={props} />
          </Space>
          <hr />
          <List
            dataSource={response}
            loading={loadingSec}
            renderItem={(item: any) => (
              <List.Item>
                <Card>
                  <RowLine>
                    <p>
                      <strong>Fornecedor</strong> <SpanBlock>{item.fornecedor}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Nº nota</strong> <SpanBlock>{item.nuNota}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Destinatário</strong> <SpanBlock>{item.destinatario}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Peso Bruto</strong>{' '}
                      <SpanBlock>{maskUnd(item.pesoBruto) + ' KG'}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <p>
                      <strong>Valor</strong> <SpanBlock>{maskCurrency(item.valor)}</SpanBlock>
                    </p>
                  </RowLine>
                  <RowLine>
                    <ModalUpload nuNota={item.nuNota} />
                  </RowLine>
                </Card>
              </List.Item>
            )}
          />
        </>
      </Panel>
    </Collapse>
  );
};

export default CardSecMobile;
